var _templateObject = _taggedTemplateLiteralLoose(["\n   width: 100%; \n   padding: 0;\n  "], ["\n   width: 100%; \n   padding: 0;\n  "]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n   width: 80%;\n   padding: 2em;\n  "], ["\n   width: 80%;\n   padding: 2em;\n  "]),
    _templateObject3 = _taggedTemplateLiteralLoose([" \n   width: 60%;\n   max-width: 500px;\n   padding: 2em;\n  "], [" \n   width: 60%;\n   max-width: 500px;\n   padding: 2em;\n  "]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from "react";
import styled, { css } from "styled-components";
import { media } from "../index";

var View = styled.div.withConfig({
  displayName: "View",
  componentId: "b52d2e-0"
})(["margin:0 auto;", ";", ";", ";", ";"], function (props) {
  return props.center && css(["text-align:center;"]);
}, media.phone(_templateObject), media.tablet(_templateObject2), media.desktop(_templateObject3));

export default View;